// extracted by mini-css-extract-plugin
export var button = "F7c1u";
export var defaultButton = "i7sXU";
export var ghost = "WhyVs";
export var primary = "Xsjy4";